import * as React from 'react'

function SvgDentIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M4.236 12.41a.5.5 0 0 0-.528.85l6.436 4.008a3.5 3.5 0 0 0 3.71-.006l6.384-4.004a.5.5 0 1 0-.532-.847l-6.383 4.004a2.5 2.5 0 0 1-2.65.004L4.236 12.41Z"
        fill="#F16B0A"
      />
      <path
        d="M20.292 8.26a.5.5 0 0 0-.529-.85l-6.436 4.01a2.5 2.5 0 0 1-2.65-.005L4.294 7.411a.5.5 0 1 0-.532.847l6.384 4.004a3.5 3.5 0 0 0 3.71.006l6.436-4.009Z"
        fill="#F16B0A"
      />
    </svg>
  )
}

export default SvgDentIcon
